import { formatCpfCnpj } from '../../../../utils';

/**
 * Extrai CPFs/CNPJs de um texto colado ou de um CSV: separa por quebra de linha,
 * vírgula, ponto e vírgula ou espaço, tira a máscara, ignora tokens sem dígito
 * (cabeçalho) e repetidos. O backend valida o tamanho e devolve os inválidos em `failed`.
 */
export function parseDocumentos(texto: string): string[] {
  const docs = texto
    .split(/[\s,;]+/)
    .map((t) => t.toUpperCase().replace(/[^0-9A-Z]/g, ''))
    .filter((t) => /\d/.test(t));
  return Array.from(new Set(docs));
}

export const formatDocumento = (doc?: string | null) =>
  doc ? formatCpfCnpj(doc) : '-';

export const formatDataHora = (iso?: string | null) => {
  if (!iso) return '-';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleString('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    dateStyle: 'short',
    timeStyle: 'short',
  });
};

// Rótulos dos motivos do gestor, que o cliente vê nos bloqueios de origem gestor.
const ROTULOS_GESTOR: Record<string, string> = {
  roteamento: 'Roteamento',
  agressao: 'Agressão',
  fraude: 'Fraude',
  pedido_franquia: 'Pedido da franquia',
  documentacao_irregular: 'Documentação irregular',
  legado_inativo: 'Bloqueio anterior',
  outro: 'Outro',
};

export const rotuloMotivo = (
  codigo: string | null,
  texto: string | null,
  motivos: { codigo: string; rotulo: string }[] = []
) => {
  const rotulo = codigo
    ? (motivos.find((m) => m.codigo === codigo)?.rotulo ??
      ROTULOS_GESTOR[codigo] ??
      codigo)
    : null;
  if (rotulo && texto)
    return codigo === 'outro' ? texto : `${rotulo} — ${texto}`;
  // bloqueios antigos podem não ter motivo
  return rotulo ?? texto ?? '—';
};

export const AVISO_GESTOR =
  'Bloqueado pelo gestor — entre em contato com o gestor para alterar';
